// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2NeST","logo":"index_logo_32qMk"};